import React, { useEffect, MouseEvent } from 'react';
import { createUseStyles } from 'react-jss';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { State } from '@meraki-internal/state';
import { HistoryViewModel } from './support/HistoryViewModel';
import { mediaMaxWidth, mediaMinWidth } from './theme/utils';
import { SIDE_NAV_WIDTH } from './navigation/NavConstants';

const useStyles = createUseStyles({
    tabs: {
        width: '100%',
        backgroundColor: 'var(--ion-color-primary)',

        gap: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingBottom: 12,

        [mediaMaxWidth.sm]: {
            justifyContent: 'flex-start'
        },

        // left/right padding should match content padding in InnerhivePage
        paddingLeft: 'var(--ion-padding, 16px)',
        paddingRight: 'var(--ion-padding, 16px)',
        [mediaMinWidth.md]: {
            paddingLeft: '15%',
            paddingRight: '15%',
        },
        [mediaMinWidth.lg]: {
            paddingLeft: `calc(${SIDE_NAV_WIDTH}px + 20%)`,
            paddingRight: '20%'
        }
    }
});

export interface IHeaderTabGroup {
    tabGroupId: string;
    tabs: IHeaderTab[];
}

export interface IHeaderTab {
    label: string;
    url: string;
    dataId?: string;
    onClick?: () => void;
}

const Link: React.FC<IHeaderTab & { selected: boolean }> = ({ url, label, selected, dataId, onClick }) => {
    const blankUrl = '';
    const history = useInstance(HistoryViewModel);
    return (
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}} data-id={dataId} onClick={onClick}>
            <a style={{padding: 5, paddingBottom: 10, textDecoration: 'none', color: 'white', fontSize: 14}} href={blankUrl}
                onClick={(e: MouseEvent) => {
                    e.preventDefault();
                    e.stopPropagation();
                    history.push(url);
                }}
            >{label}</a>
            <div style={{height: 2, background: 'white', width: '100%', visibility: selected ? 'visible' : 'hidden'}} />
        </div>
    );
};

export class HeaderTabsState extends State {
    setLastActiveTab = (tabGroupId: string, tab: IHeaderTab) => {
        this.setState({[tabGroupId]: tab});
    };
    getLastActiveTab = (tabGroupId: string) => {
        return this.state?.[tabGroupId] || undefined;
    };
}

// TODO: convert to MDTabs at some point

export const HeaderTabs: React.FC<{tabs: IHeaderTabGroup}> = ({ tabs }) => {
    const classes = useStyles();
    const history = useInstance(HistoryViewModel);
    const tabsState = useInstance(HeaderTabsState);

    const pathname = history.getCurrentLocation().pathname;
    const selectedTab = tabs.tabs.find(t => pathname.startsWith(t.url));

    useEffect(() => {
        if (selectedTab) {
            tabsState.setLastActiveTab(tabs.tabGroupId, selectedTab);
        }
    }, [tabs]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className={classes.tabs}>
            {tabs.tabs.map(tab => (
                <Link
                    key={tab.label}
                    url={tab.url}
                    label={tab.label}
                    onClick={tab.onClick}
                    selected={tab === selectedTab} dataId={tab.dataId}
                />
            ))}
        </div>
    );
};
